/**
 * Cleans up a date-fns format string by removing duplicate separators and leading/trailing punctuation.
 * This is useful after removing certain parts (like year or month) from a format string.
 */
export function cleanFormat(format: string): string {
  return format
    .replace(/([-./\s,])\1+/g, '$1') // remove duplicate separators
    .replace(/^[-./\s,]+|[-./\s,]+$/g, '') // remove leading/trailing separators
    .trim();
}
